const HTML_ESCAPES = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }
const UNSAFE_CHARACTER = new RegExp(`[${Object.keys(HTML_ESCAPES).join("")}]`, "g")

export default function escapeHtml(value) {
  return String(value).replace(UNSAFE_CHARACTER, character => HTML_ESCAPES[character])
}
